import { render } from "./NavbarTwoSafest.vue?vue&type=template&id=d4dfc166"
import script from "./NavbarTwoSafest.vue?vue&type=script&lang=js"
export * from "./NavbarTwoSafest.vue?vue&type=script&lang=js"

import "./NavbarTwoSafest.vue?vue&type=style&index=0&id=d4dfc166&lang=css"

import exportComponent from "D:\\wamp64\\www\\safest\\node_modules\\@vue\\cli-service\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__